export const styles = {
  search: {
    display: "flex",
    alignItems: "center",
  },
};
